module.exports = __webpack_public_path__ + "static/9-797ddda9d3f09fbf875f70d02d532373.png";